import { createStore } from '@cobuildlab/react-simple-state';

export const changeStepStore = createStore<{ step: number }>({
  initialValue: {
    step: 1,
  },
});
